import type { SxProps, Theme } from '@mui/material';

import { ExtranetPendingChangeStatus } from '~/services/ExtranetService';

import { getExtranetApprovalFilterOptions } from './extranetApprovalLabels';
import type { Filters } from './types';

export const REQUEST_TYPE_OPTIONS = getExtranetApprovalFilterOptions();

export const TAB_CHIP_COLORS: Record<string, SxProps<Theme>> = {
  Rooms: { bgcolor: 'info.light', color: 'info.contrastText' },
  Description: { bgcolor: 'secondary.light', color: 'secondary.contrastText' },
  Policies: { bgcolor: 'warning.light', color: 'warning.contrastText' },
  'Property Details': { bgcolor: 'primary.light', color: 'primary.contrastText' },
  Taxes: { bgcolor: 'success.light', color: 'success.contrastText' },
  Facilities: { bgcolor: 'info.dark', color: 'info.contrastText' },
  Images: { bgcolor: 'error.light', color: 'error.contrastText' },
};

export const STATUS_CHIP_COLOR: Record<ExtranetPendingChangeStatus, 'warning' | 'success' | 'error' | 'default'> = {
  pending: 'warning',
  approved: 'success',
  rejected: 'error',
  superseded: 'default',
};

export const HEADER_CELL_SX: SxProps<Theme> = {
  fontWeight: 700,
  fontSize: 11,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  color: 'text.secondary',
};

export const PAGE_SIZE = 50;
export const PENDING_TAB = 0;
export const HOMES_VILLAS_PENDING_TAB = 1;
export const HISTORY_TAB = 2;

export const DEFAULT_FILTERS: Filters = {
  status: 'pending',
  vendor_id: '',
  request_type: '',
  property_id: '',
  property_category: '',
};
